import { UserDetail } from "../models/user-detail.model";
import { UserDetailStateModel } from "../state/user-detail.state";

export namespace UserDetailActions {
    export class Refresh {
        static readonly type = '[API-UserDetail] Refresh'
        constructor() {}
    }
    export class Init {
        static readonly type = '[Storage-UserDetail] Init'
        constructor(public payload: UserDetailStateModel) {}
    }
    export class Set {
        static readonly type = '[API-UserDetail] Set'
        constructor(public payload: UserDetail) {}
    }
}
